/**
 * The handful of icons settings needs, drawn inline.
 *
 * Inline because the panel runs inside Zoho Desk under a content policy that
 * blocks outside requests: an icon font from a CDN would render nothing. These
 * are stroked paths on a 24-unit grid, sized by `font-size` at the call site
 * like text, so a row's icon and its label stay proportional.
 */
const PATHS: Record<string, string> = {
  link: 'M10 13a4 4 0 0 0 5.66 0l2-2a4 4 0 0 0-5.66-5.66l-1 1 M14 11a4 4 0 0 0-5.66 0l-2 2a4 4 0 0 0 5.66 5.66l1-1',
  unlink: 'M17 7l3-3 M7 17l-3 3 M10 13a4 4 0 0 0 5.66 0l1-1 M14 11a4 4 0 0 0-5.66 0l-1 1',
  spark: 'M12 3.5l1.9 5.4 5.4 1.9-5.4 1.9-1.9 5.4-1.9-5.4-5.4-1.9 5.4-1.9z',
  docs: 'M15 3H6a2 2 0 0 0-2 2v11 M8 7h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z',
  chat: 'M20 12a7 7 0 0 1-7 7H9l-4 3v-4.2A7 7 0 0 1 9 5h4a7 7 0 0 1 7 7z',
  bolt: 'M13 3L6 13.5h5.2L11 21l7-10.5h-5.2z',
  tick: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z M8.2 12.4l2.6 2.6 5-5.6',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M5 20a7 7 0 0 1 14 0',
  chevron: 'M9.5 6l6 6-6 6',
}

export type IconName = keyof typeof PATHS

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name].split(' M').map((d, i) => (
        <path key={i} d={i === 0 ? d : `M${d}`} />
      ))}
    </svg>
  )
}
